var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"root"},[_c('div',{staticClass:"container-shell"},[_c('div',{ref:"container",attrs:{"id":"container"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }